import { useEffect, useState } from "react";
import api from "../../lib/api";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/admin/users").then((r) => setUsers(r.data)); }, []);

  return (
    <div data-testid="admin-users">
      <h1 className="font-serif text-4xl text-brand-dark mb-8">Customers</h1>
      <div className="bg-white border border-brand-line rounded-2xl overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-brand-subtle text-xs uppercase tracking-wider text-brand-muted">
            <tr>
              <th className="text-left p-3">Name</th>
              <th className="text-left p-3">Email</th>
              <th className="text-left p-3">Phone</th>
              <th className="text-left p-3">Role</th>
              <th className="text-left p-3">Method</th>
              <th className="text-left p-3">Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.user_id} className="border-t border-brand-line" data-testid={`admin-user-${u.user_id}`}>
                <td className="p-3 font-medium">{u.name}</td>
                <td className="p-3 text-brand-muted">{u.email}</td>
                <td className="p-3 text-brand-muted">{u.phone || "—"}</td>
                <td className="p-3"><span className={`text-xs uppercase tracking-wider px-2 py-1 rounded-full ${u.role === "admin" ? "bg-brand-chili text-white" : "bg-brand-subtle"}`}>{u.role}</span></td>
                <td className="p-3 text-xs text-brand-muted">{u.auth_provider}</td>
                <td className="p-3 text-xs text-brand-muted">{new Date(u.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
